import { queryOptions, useQuery } from '@tanstack/react-query';

import { inventoryApi } from '../api/inventory-api';

import { inventoryKeys } from './inventory-keys';

export function stockLocationsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: inventoryKeys.locations(storeId),
    queryFn: () => inventoryApi.listLocations(storeId),
  });
}

export function useStockLocations(storeId: string) {
  return useQuery(stockLocationsQueryOptions(storeId));
}
